import React, { useEffect } from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import jssVariables from "../../jss_setup";
import { InlineIcon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import { Button } from "../../components/common/Button";

const styles = createUseStyles({
  HotelsRedirector: (props) => ({
    paddingTop: jssVariables.navbar_height,
    display: "grid",
    placeItems: "center",
    ..._.get(props, "customStyles.HotelsRedirector", {}),
  }),
  icon: (props) => ({
    color: jssVariables.colors.base_color,
    fontSize: "xxx-large",
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const HotelsRedirector = ({ session_id }) => {
  const classes = styles({});

  const history = useHistory();

  function redirect() {
    setTimeout(() => history.push(`/hotels/${session_id}`), 2000);
  }

  useEffect(() => {
    redirect();
  }, []);

  return (
    <div className={classes.HotelsRedirector}>
      <InlineIcon
        icon="line-md:loading-twotone-loop"
        className={classes.icon}
      />
      {/* <Button text="go" onClick={() => redirect()} /> */}
    </div>
  );
};
HotelsRedirector.defaultProps = {};
HotelsRedirector.propTypes = {
  session_id: PropTypes.string.isRequired,
};
export default HotelsRedirector;
